/*
 *  Kode for validering av fødselsnummer
 *
 *  updated 08 Feb 2021
 *  by Lars Erik Storbukås <https://github.com/storbukas>
 *
 *  Source: https://github.com/storbukas/norsk-validator
 *
 *  Licensed under the MIT License
 *  https://opensource.org/licenses/MIT
 *
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var MOD11 = 11;
var vekttallKontrollsiffer1 = [3, 7, 6, 1, 8, 9, 4, 5, 2];
var vekttallKontrollsiffer2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
var PERIOD_COMMA_SPACE_REGEX = /[,.\s]/g;
var vekttallSum = function (fodselsnummer, factors) {
    var sum = 0;
    var l = factors.length;
    for (var i = 0; i < l; i += 1) {
        sum += parseInt(fodselsnummer.charAt(i), 10) * factors[i];
    }
    return sum;
};
var fodselsnummer = function (fodselsnummer) {
    var fodselsnummerString = fodselsnummer.toString()
        .replace(PERIOD_COMMA_SPACE_REGEX, '');
    if (!fodselsnummerString || fodselsnummerString.length !== 11) {
        return false;
    }
    var kontrollsiffer1 = MOD11 - (vekttallSum(fodselsnummerString, vekttallKontrollsiffer1) % MOD11);
    if (kontrollsiffer1 === MOD11) {
        kontrollsiffer1 = 0;
    }
    var kontrollsiffer2 = MOD11 - (vekttallSum(fodselsnummerString, vekttallKontrollsiffer2) % MOD11);
    if (kontrollsiffer2 === MOD11) {
        kontrollsiffer2 = 0;
    }
    return kontrollsiffer1 === parseInt(fodselsnummerString.charAt(9), 10)
        && kontrollsiffer2 === parseInt(fodselsnummerString.charAt(10), 10);
};
exports.default = fodselsnummer;
